// extracted by mini-css-extract-plugin
module.exports = {"filePreview":"FilePreview_filePreview__Dx8fa","imagePreview":"FilePreview_imagePreview__TiT6j","filePreviewContent":"FilePreview_filePreviewContent__mmhu4"};